import React, {FC, ReactNode} from 'react';
import {Button} from './Primitives';
import {Icon, IconName} from './Icon';
import {cx} from './cx';

interface SpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Spinner: FC<SpinnerProps> = ({
  label = 'Loading',
  size = 'md',
}) => (
  <span className="sui-spinner-wrap" role="status">
    <span
      aria-hidden="true"
      className={cx('sui-spinner', `sui-spinner--${size}`)}
    />
    <span className="sui-sr-only">{label}</span>
  </span>
);

interface NoticeProps {
  title: string;
  children?: ReactNode;
  tone?: 'info' | 'success' | 'warm' | 'error';
  icon?: IconName;
  className?: string;
}

const noticeIcons: Record<NonNullable<NoticeProps['tone']>, IconName> = {
  info: 'sparkle',
  success: 'check',
  warm: 'heart',
  error: 'close',
};

export const Notice: FC<NoticeProps> = ({
  title,
  children,
  tone = 'info',
  icon,
  className,
}) => (
  <div
    className={cx('sui-notice', `sui-notice--${tone}`, className)}
    role={tone === 'error' ? 'alert' : 'status'}
  >
    <Icon name={icon || noticeIcons[tone]} size={20} />
    <div>
      <strong>{title}</strong>
      {children && <div>{children}</div>}
    </div>
  </div>
);

interface EmptyStateProps {
  image: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export const EmptyState: FC<EmptyStateProps> = ({
  image,
  title,
  description,
  actionLabel,
  onAction,
  className,
}) => (
  <div className={cx('sui-empty-state', className)}>
    <img alt="" src={image} />
    <div>
      <h3>{title}</h3>
      <p>{description}</p>
      {actionLabel && onAction && (
        <Button iconStart="plus" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  </div>
);
